import { FC, useCallback, useState } from 'react'

// TODO change to Suspense when it's stable
type ErrorHandlerProps = {
  component: FC<{ onError: VoidFunction }>
  errorComponent: FC
}

export const ErrorHandler: FC<ErrorHandlerProps> = ({ component: Component, errorComponent: ErrorComponent }) => {
  const [hasError, setHasError] = useState(false)
  const showError = useCallback(() => setHasError(true), [])

  if (hasError) {
    return <ErrorComponent />
  }

  return <Component onError={showError} />
}
